import { api_POST } from "services/api_service.js";
import { showMessage } from "./message";

export const CancelarRequerimentoByRequerimento = (requerimento_Id, usuario_Id, json, callback) => {
    api_POST(`requerimento/PostCancelaRequerimento/${requerimento_Id}/` + usuario_Id, json)
        .then(result => { callback(result); })
        .catch(err => showMessage("Aviso", err.message, 'error', null))
}

export const CancelarRequerimentoByProtocolo = (protocolo_Id, json, callback) => {
    api_POST(`requerimento/CancelaRequerimentoByProtocolo/${protocolo_Id}`, json)
        .then(result => { callback(result); })
        .catch(err => showMessage("Aviso", err.message, 'error', null))
}